import { CategoryApi, JobApi } from 'api-typings/common/common';
import { Category, Job } from './jobs.model';

export function transformJob(job: JobApi): Job {
  if (!job.name || !job.seo_url) {
    throw new ReferenceError(`Job missing required fields`);
  }

  return {
    id: job.id,
    name: job.name,
    category: transformCategory(job.category),
    local: job.local || false,
    seoUrl: job.seo_url,
  };
}

function transformCategory(category?: CategoryApi): Category | undefined {
  return category
    ? {
        id: category.id,
        name: category.name,
      }
    : undefined;
}
